import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import capitalize from 'scaleflow/utils/capitalize';

export default class PlanningDashboardOverviewGridController extends Controller {
  queryParams = [
    'column',
    'row',
    'effort',
    'uncertainties',
    'waiting',
    'updatedAt',
    'tickets',
    'hiddenRows',
    'hiddenColumns',
  ];
  @tracked column = 'status';
  @tracked row = 'teams';
  @tracked effort = false;
  @tracked uncertainties = false;
  @tracked tfos = false;
  @tracked waiting = false;
  @tracked updatedAt = false;
  @tracked tickets = false;
  @tracked slideoverIsOpen = false;
  @tracked hiddenRows = '';
  @tracked hiddenColumns = '';

  @service roadmap;
  @service intl;

  get activeFieldsMap() {
    return {
      effort: this.effort,
      uncertainties: this.uncertainties,
      tfos: this.tfos,
      waiting: this.waiting,
      updatedAt: this.updatedAt,
      tickets: this.tickets,
    };
  }

  get fieldOptions() {
    return [
      {
        label: this.intl.t('dictionary.effort'),
        value: 'effort',
        checked: this.effort,
      },
      {
        label: this.intl.t('dictionary.uncertainty', { num: 2 }),
        value: 'uncertainties',
        checked: this.uncertainties,
      },
      {
        label: this.intl.t('dictionary.waiting-for-answers'),
        value: 'waiting',
        checked: this.waiting,
      },
      {
        label: this.intl.t('dictionary.last-updated'),
        value: 'updatedAt',
        checked: this.updatedAt,
      },
      {
        label: this.intl.t('_initiatives.tickets'),
        value: 'tickets',
        checked: this.tickets,
      },
    ];
  }

  get activeFields() {
    return this.fieldOptions.reduce((acc, field) => {
      if (field.checked !== true);
      else acc.push(field);
      return acc;
    }, []);
  }

  get activeFieldsKeys() {
    return this.activeFields.reduce((acc, item) => {
      acc.push(item.value);
      return acc;
    }, []);
  }

  @action
  setColumn(e) {
    this.column = e.value;
  }

  @action
  setRow(e) {
    this.row = e.value;
  }

  @action
  toggleFilterSlideover() {
    this.slideoverIsOpen = !this.slideoverIsOpen;
  }

  get options() {
    return [
      {
        label: capitalize(
          this.intl.t('_initiatives.source', {
            num: 1,
          }),
        ),
        value: 'source',
      },
      {
        label: capitalize(this.intl.t('_initiatives.status')),
        value: 'status',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.teams', {
            num: 1,
          }),
        ),
        value: 'teams',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.themes', {
            num: 1,
          }),
        ),
        value: 'theme',
      },
      {
        label: capitalize(this.intl.t('_initiatives.progress')),
        value: 'progress',
      },
      {
        label: capitalize(
          this.intl.t('dictionary.goals', {
            num: 1,
          }),
        ),
        value: 'goals',
      },
    ];
  }

  @action
  onFieldSelect(fields) {
    this.fieldOptions.forEach((item) => {
      if (fields.includes(item.value)) this[item.value] = true;
      else this[item.value] = false;
    });
  }

  @action
  updateRowFilters(hiddenRows) {
    this.hiddenRows = JSON.stringify(hiddenRows);
  }

  @action
  updateColumnFilters(hiddenColumns) {
    this.hiddenColumns = JSON.stringify(hiddenColumns);
  }
}
